import styled from 'styled-components'

import { theme } from 'styles/theme'

import { fluidType } from '../fluid-type'

const { media, space } = theme

export { Section } from 'components/general-styles/General'

export const TitleWrapper = styled.div`
  h2,
  h2 span {
    margin: 0;
    font-size: ${fluidType.sectionTitle};
    letter-spacing: -0.02em;
  }
`

export const Questions = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xl']};
  margin-top: ${space['spacing-xl']};

  @media (${media.desktop}) {
    margin-top: 0;
  }
`

export const Question = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['spacing-xxs']};

  h3,
  p {
    margin: 0;
  }

  h3 {
    /* 36px no desenho — o mesmo passo dos pilares do hero. */
    font-size: ${fluidType.pillar};
    letter-spacing: -0.02em;
  }
`
